/**
 * Created by chachora on 12/17/18.
 */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import * as selectors from '../../store/selectors';
import { indigo } from '@mui/material/colors';

class Event extends PureComponent {
  handleSelect = () => {
    const { event, onSelect } = this.props;
    onSelect?.(event);
  };

  render() {
    const { classes, className, event, airports } = this.props;
    const airport = airports.find(
      a => a.name.toUpperCase() === event.airport.toUpperCase()
    );
    const borderLeftColor = airport ? airport.color : '#000';

    return (
      <div
        className={classNames(classes.container, className)}
        style={{ borderLeftColor }}
        onClick={this.handleSelect}
      >
        <span
          className={classNames(classes.textContainer, {
            [classes.notSameDay]: !event.isSameDay,
          })}
        >
          {event.title}
        </span>
      </div>
    );
  }
}

const styles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderLeft: '3px solid',
    paddingLeft: '4px',
  },
  notSameDay: {
    backgroundColor: indigo['400'],
    color: 'white',
    width: '100%',
  },
  textContainer: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
});

export default connect(state => ({
  airports: selectors.getAirports(state),
}))(withStyles(styles)(Event));
